module.exports = __webpack_public_path__ + "img/qiezhiji.97ed3420.jpg";